(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bloque-carrusel-videos"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-videos-carrusel]').forEach(function (contenedor) {
    var autoplay = contenedor.dataset.autoplay === 'true';
    var tarjetas = contenedor.querySelectorAll('[data-videos-tarjeta]');

    tarjetas.forEach(function (tarjeta) {
      var video = tarjeta.querySelector('video');
      var boton = tarjeta.querySelector('[data-videos-sonido]');
      var iconoSilenciado = tarjeta.querySelector('[data-icono-silenciado]');
      var iconoSonido = tarjeta.querySelector('[data-icono-sonido]');
      if (!video) return;

      if (boton) {
        boton.addEventListener('click', function (evento) {
          evento.stopPropagation();
          video.muted = !video.muted;
          if (iconoSilenciado && iconoSonido) {
            iconoSilenciado.style.display = video.muted ? 'block' : 'none';
            iconoSonido.style.display = video.muted ? 'none' : 'block';
          }
        });
      }

      tarjeta.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    });

    if (autoplay && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            var video = entrada.target.querySelector('video');
            if (!video) return;
            if (entrada.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.6 }
      );

      tarjetas.forEach(function (tarjeta) {
        observador.observe(tarjeta);
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bloque-mensajes-rotativos"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-ticker]').forEach(function (contenedor) {
    var mensajes = contenedor.querySelectorAll('[data-ticker-mensaje]');
    if (mensajes.length < 2) return;

    var velocidad = (parseInt(contenedor.dataset.velocidad, 10) || 3) * 1000;
    var indiceActual = 0;

    setInterval(function () {
      mensajes[indiceActual].classList.remove('pi-ticker__mensaje--activo');
      indiceActual = (indiceActual + 1) % mensajes.length;
      mensajes[indiceActual].classList.add('pi-ticker__mensaje--activo');
    }, velocidad);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bloque-resenas-slider"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-resenas-slider]').forEach(function (contenedor) {
    var pista = contenedor.querySelector('[data-resenas-pista]');
    var anterior = contenedor.querySelector('[data-resenas-prev]');
    var siguiente = contenedor.querySelector('[data-resenas-next]');
    if (!pista || pista.children.length < 2) return;

    var autoplay = contenedor.dataset.autoplay === 'true';
    var velocidad = (parseInt(contenedor.dataset.velocidad, 10) || 4) * 1000;
    var temporizador = null;

    function avanzar() {
      var ancho = pista.clientWidth;
      var maximo = pista.scrollWidth - ancho;
      if (pista.scrollLeft >= maximo - 2) {
        pista.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        pista.scrollBy({ left: ancho, behavior: 'smooth' });
      }
    }

    function retroceder() {
      var ancho = pista.clientWidth;
      if (pista.scrollLeft <= 2) {
        pista.scrollTo({ left: pista.scrollWidth, behavior: 'smooth' });
      } else {
        pista.scrollBy({ left: -ancho, behavior: 'smooth' });
      }
    }

    function iniciarAutoplay() {
      if (!autoplay) return;
      temporizador = setInterval(avanzar, velocidad);
    }

    function detenerAutoplay() {
      if (temporizador) {
        clearInterval(temporizador);
        temporizador = null;
      }
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        detenerAutoplay();
        avanzar();
        iniciarAutoplay();
      });
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        detenerAutoplay();
        retroceder();
        iniciarAutoplay();
      });
    }

    iniciarAutoplay();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
